import React, { Component } from 'react';
import { withNavigation } from 'react-navigation';

class SocialAuth extends Component {
  render() {
    if (this.props.visible === false) {
      return <></>;
    }
    return this.props.render(this.onLogin);
  }

  onLogin = async () => {
    const { providerId, type } = this.props;
    window.localStorage.setItem('socialAuthFirstLoad', true);
    this.props.navigation.navigate('SocialAuthLoading', {
        providerId,
        type
    });
  }
}

export default withNavigation(SocialAuth);
